import React, { createContext, useCallback, useContext, useId, useMemo, useState } from 'react';
import { useAccess } from '../../Context/AccessContext';

const HeaderDropdownContext = createContext({
    activeSubmenus: {},
    level: 0,
    openSubmenu: () => {},
});

export const HeaderDropdownProvider = ({ children }) => {
    const [activeSubmenus, setActiveSubmenus] = useState({});

    const openSubmenu = useCallback((level, id) => {
        setActiveSubmenus(currentSubmenus => {
            const nextSubmenus = {};

            Object.keys(currentSubmenus).forEach(key => {
                if(Number(key) < level){
                    nextSubmenus[key] = currentSubmenus[key];
                }
            });

            nextSubmenus[level] = id;
            return nextSubmenus;
        });
    }, []);

    const contextValue = useMemo(() => ({
        activeSubmenus,
        level: 0,
        openSubmenu,
    }), [activeSubmenus, openSubmenu]);

    return (
        <HeaderDropdownContext.Provider value={contextValue}>
            {children}
        </HeaderDropdownContext.Provider>
    );
};

const HeaderDropdown = ({ children, label='' }) => {

    const { getAccess, accessLoaded } = useAccess();
    const { activeSubmenus, level, openSubmenu } = useContext(HeaderDropdownContext);
    const id = useId();
    const isOpen = activeSubmenus[level] === id;

    const handleOpen = useCallback(() => {
        openSubmenu(level, id);
    }, [id, level, openSubmenu]);

    const show = useMemo(() => {
        if(!accessLoaded) return false;
        let returnValue;
        React.Children.forEach(children, child => {
            if(child.props.acesso && getAccess(child.props?.acesso)?.opcao_menu){
                returnValue = true;
            }
        });
        return returnValue;
    }, [accessLoaded, getAccess, children]);

    if(show){
        return (
            <li className={isOpen ? 'main-nav-submenu-open' : ''} onMouseEnter={handleOpen}>
                <button onClick={handleOpen} onFocus={handleOpen}>
                    { label }
                </button>
                <ul>
                    <HeaderDropdownContext.Provider value={{ activeSubmenus, level: level + 1, openSubmenu }}>
                        { children }
                    </HeaderDropdownContext.Provider>
                </ul>
            </li>
        );
    }
    return;
};

export default HeaderDropdown;